export enum ProductActionTypes {
    API_RESPONSE_SUCCESS = '@@product/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@product/API_RESPONSE_ERROR',

    GET_PRODUCTS = '@@product/GET_PRODUCTS',
    ADD_PRODUCT = '@@product/ADD_PRODUCT',
    UPLOAD_IMAGE = '@@product/UPLOAD_IMAGE',
    GET_PRODUCT_DETAILS = '@@product/GET_PRODUCT_DETAILS',
    UPDATE_PRODUCT = '@@product/UPDATE_PRODUCT',
    DELETE_PRODUCT = '@@product/DELETE_PRODUCT',
    BULK_IMPORT_PRODUCTS = '@@product/BULK_IMPORT_PRODUCTS',
    RESET_IMPORT_STATE = '@@product/RESET_IMPORT_STATE'
}
